import dayjs from 'dayjs';
import { guid } from './uuid';

export const STATIC_RESOURCE = 'https://fe-ifarm.cpgroupcloud.com/static_resource';

//路由处理
export const format_routes = (data) => {
  return data.flatMap(({ children, ...item }) => [
    ...(item.path ? [item] : []),
    ...(children ? format_routes(children) : [])
  ]);
};

//截取制定长度的数组
export function chunk(array, size = 1) {
  return Array.from({ length: Math.ceil(array.length / size) }, (_, i) => array.slice(i * size, (i + 1) * size));
}

export const pathSliceMatch = (path) => {
  return path.split('/').filter(item => !/\d/.test(`${item}`)).join('/').replace(/\/:.*/ig, '');
};

export function string2decimal(string_number = '') {
  const formateNumber = `${string_number}`.replace(/[^\d|^.|^-]/g, '');
  const formateNumberResult = formateNumber.includes('-') ? '-' + formateNumber.replace(/-/ig, '') : formateNumber;
  return formateNumberResult ? `${parseFloat(formateNumberResult)}` : '';
};

export function getItem(label, key, icon, children, type) {
  return { key, icon, children, label, type, title: label };
};

//菜单权限处理
export const format_route = ({ routes = [], menusList = [], $t = label => label }) => {
  const menuKeys = new Set(menusList.map(m => m.key));
  return routes.filter(item => !item.hidden && menuKeys.has(item.key)).map(item => {
    const { label, key, path, children = [] } = item;
    const format_route_children = children.length ? format_route({ routes: children, menusList, $t }) : undefined;
    return getItem($t(label), key, '', format_route_children, path);
  });
};

// 排序方式：3-倒序 4-正序
export const ascendConfig = { ascend: 4, descend: 3 };

//格式化排序给后端
export function formatSortParamsToSever(sortParams = {}) {
  return Reflect.ownKeys(sortParams).filter(item => !item.includes('_sorter')).reduce((pre, cur) => ({ ...pre, [cur]: sortParams[cur] }), {});
};

//格式化表格排序
export function formatTableSortParams(sorter, customFlag = '_sorter') {
  return (Array.isArray(sorter) ? sorter : [sorter]).filter(item => item.order).reduce((acc, cur, index) => ({ ...acc, [cur.field]: { sort: ascendConfig?.[cur.order], index }, [`${cur.columnKey}${customFlag}`]: cur.order }), {});
};
//数组对象过滤
export function formatFilterArray(arr = [], key) {
  const map = new Map();
  for (const item of arr) {
    if (!map.has(item[key])) {
      map.set(item[key], item);
    };
  };
  return [...map.values()];
};

export function formatTreeData(data) {
  const newData = [];
  for (const item of data) {
    newData.push({ value: `${guid()}&${item.key}-${item.value}`, title: item.name, children: formatTreeData(item.items) });
  }
  return newData;
};

// 判断数组含有某一组值
export function hasGroupInArray(arr, group) {
  return group.every(item => arr.includes(item));
}

//数组交集
export function intersection(arr1, arr2) {
  return arr1.filter(item => arr2.includes(item));
}

export function getAllParams(url = window.location.search) {
  return Object.fromEntries((new URLSearchParams(url)).entries());
}

export function isIntegerMultiple(inputNum, a) {//是否为整数倍
  if (typeof inputNum !== 'number' || typeof a !== 'number' || isNaN(inputNum) || isNaN(a)) {
    console.error('输入必须是有效数字！');
    return false;
  }
  if (a === 0) {
    console.error('参考数a不能为0！');
    return false;
  }
  const remainder = inputNum % a;
  const precision = 1e-10; // 浮点精度容错值
  return Math.abs(remainder) < precision;
}

export function getYearMonth(date) {
  const totalMonths = Math.ceil(dayjs().diff(date, 'month', true));
  const year = Math.floor(totalMonths / 12);
  const month = totalMonths % 12;

  return { totalMonths, totalMonthsText: `${totalMonths}个月`, year, month, text: `${year}年${month}个月` };
};

export const isBase64 = (str) => {
  if (!str) return false;
  const base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;
  return base64Regex.test(str.replace(/\s/g, ''));
};

export const chineseTextToNumber = (text = '') => {
  const dict = new Map([['一', 1], ['壹', 1], ['二', 2], ['贰', 2], ['三', 3], ['叁', 3], ['四', 4], ['肆', 4], ['五', 5], ['伍', 5], ['六', 6], ['陆', 6], ['七', 7], ['柒', 7], ['八', 8], ['捌', 8], ['九', 9], ['玖', 9], ['十', 10], ['拾', 10], ['百', 100], ['佰', 100], ['千', 1000], ['仟', 1000], ['万', 10000], ['亿', 100000000]]);
  const clean = text.replace(/[^\d.零一二三四五六七八九十百千万亿壹贰叁肆伍陆柒捌玖拾佰仟]/g, '');

  // 处理阿拉伯数字+中文单位的混合格式，如 "150万", "2.5亿"
  const numWithUnit = clean.match(/(\d+\.?\d*)(万|亿)/);
  if (numWithUnit) {
    const num = parseFloat(numWithUnit[1]);
    const unit = dict.get(numWithUnit[2]);
    return num * unit;
  }

  // 如果是纯数字，直接返回
  if (Number.isFinite(+clean)) {
    return +clean;
  }

  // 使用栈算法处理纯中文数字
  const stack = [];
  for (const c of clean) {
    const v = dict.get(c);
    if (v === undefined) continue; // 跳过未识别字符

    if (v < 10) {
      // 基本数字（一~九）
      stack.push(v);
    } else if (v < 10000) {
      // 小单位（十、百、千）- 与栈顶元素相乘
      if (stack.length === 0) {
        // 如 "十万"，前面没有数字，默认是1
        stack.push(v);
      } else {
        const top = stack.pop();
        stack.push(top * v);
      }
    } else {
      // 大单位（万、亿）- 栈中所有元素相加后乘以单位
      const sum = stack.reduce((a, b) => a + b, 0) || 1;
      stack.length = 0;
      stack.push(sum * v);
    }
  }

  return stack.reduce((a, b) => a + b, 0);
};

/**
 * 格式化日期字符串，支持"长期"特殊处理
 * @param {string} dateStr - 日期字符串，格式 YYYYMMDD
 * @returns {dayjs.Dayjs|string} dayjs 对象或原字符串
 */
export const formattedDate = (dateStr) => {
  if (!dateStr) return dateStr;
  if (dateStr.includes('长期')) {
    return dayjs('29991231', 'YYYYMMDD');
  }
  const parsed = dayjs(dateStr);
  if (parsed.isValid()) return parsed;
  return dayjs(dateStr, 'YYYYMMDD');
};

/**
 * OCR API 映射表：许可证类型 -> OCR 接口
 */
export const OCR_API_MAP = {
  production_processing_license: 'publicOcrProLicense',
  food_processing_license: 'publicOcrProLicense',
  io_qualifications: 'publicOcrIeQualification',
};